import workspaceQuery from '../../queries/product/ProductsStockTransferWorkspaceQuery.graphql';
import listQuery from '../../queries/product/ProductsStockTransferListQuery.graphql';
import instanceQuery from '../../queries/product/ProductsStockTransferQuery.graphql';
import defaultQuery from '../../queries/product/ProductsStockTransferDefault.graphql';
import mutationQuery from '../../mutations/product/ProductsStockTransferMutation.graphql';
import fragment from '../../fragments/product/ProductsStockTransferFragment.graphql';
import { ALLOW_ADD, ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { workspaceActionsForPermissions } from '../../../actions/product/StockTransferWorkspaceActions';
import { EntityType } from '../../../@types/entityTypes';
import { formActionsForPermissions } from '../../../actions/product/StockTransferActions';

const StockTransfer: EntityType = {
  type: 'StockTransfer',
  title: 'Stock Transfers',
  formTitle: 'Stock Transfer',
  formUrl: '/Products/StockControl/StockTransfer/Details/',
  workspaceUrl: '/Products/StockControl/StockTransfer/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentReference',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_TRANSFERS',
  actions: [...workspaceActionsForPermissions, ...formActionsForPermissions],
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW | ALLOW_DELETE,
};

export default StockTransfer;
